
import TheHeader from "../components/partials/Header/TheHeader.vue";
import TheSeoHiddenNavbar from "../components/partials/Header/TheSeoHiddenNavbar.vue";
// import EventPopup from "../components/partials/EventPopup.vue";

export default {
  name: "DefaultLayout",

  components: { TheHeader, TheSeoHiddenNavbar },
  data() {
    return {
      drawer: false,
      user: "",
    };
  },

  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
  },
  mounted() {
    this.$vuetify.rtl = true;
  },
};
